import { Grid, Typography } from "@mui/material";
import { Accordion, AccordionDetails } from '@mui/material';
import Curva from "../components/Curva";
import CarrosselNoticias from "../components/CarrosselNoticias";
import CarrosselConvidados from "../components/CarrosselConvidados";
import Logomarcas from '../images/Logomarcas.png';
import NumerosEvento from "../components/NumerosEvento";
import BotaoProgramacao from '../components/BotaoProgramacao'
import CardsEnd from "../components/CardsEnd";
import ProgramacaoPrincipal from '../images/Principal.png'
import ProgramacaoParalela from '../images/Paralela.png'
import * as React from 'react';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import CssBaseline from '@mui/material/CssBaseline';
import Drawer from '@mui/material/Drawer';
import IconButton from '@mui/material/IconButton';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemText from '@mui/material/ListItemText';
import MenuIcon from '@mui/icons-material/Menu';
import Toolbar from '@mui/material/Toolbar';
import Button from '@mui/material/Button';
import { Popover } from "@mui/material";
import BotaoValores from "../components/BotaoValores";
import BotaoDec from '../components/BotaoDec'
import { Link } from 'react-router-dom';
import Logos from '../images/Logos.png';
import Footer from "../components/Footer";
import BotaoCertidoes from "../components/BotaoCertidoes";
import BotaoOrientacoes from "../components/BotaoOrientacoes";

const drawerWidth = 240;

const navItems = [
    { route: '/programacao', text: 'Programação' },
    { route: '/galeria', text: 'Galeria' },
    { popover: true, text: 'Dúvidas' },
    { route: 'https://credmarcha.cnm.org.br', text: 'Certificados XXV Marcha' },
];

export default function Home(props) {

    const { window } = props;
    const [mobileOpen, setMobileOpen] = React.useState(false);
    const [popoverAnchor, setPopoverAnchor] = React.useState(null);

    const handleDrawerToggle = () => {
        setMobileOpen((prevState) => !prevState);
    };

    const handlePopoverOpen = (event) => {
        setPopoverAnchor(event.currentTarget);
    };

    const handlePopoverClose = () => {
        setPopoverAnchor(null);
    };

    // const drawer = (
    //     <Box onClick={handleDrawerToggle} sx={{ textAlign: 'center' }}>
    //         <List>
    //             {navItems.map((item) => (
    //                 <ListItem key={item.text} disablePadding>
    //                     <ListItemButton sx={{ textAlign: 'center' }}>
    //                         <Link to={item.route} style={{ textDecoration: 'none', color: 'inherit' }}>
    //                             <ListItemText primary={item.text} />
    //                         </Link>
    //                     </ListItemButton>
    //                 </ListItem>
    //             ))}
    //         </List>
    //     </Box>
    // );

    const container = window !== undefined ? () => window().document.body : undefined;

    return (
        <div className="background">
            <Box sx={{ display: 'flex' }}>
                <CssBaseline />
                <AppBar
                    component="nav"
                    sx={{
                        backgroundColor: 'transparent',
                        borderBottom: 0,
                        boxShadow: 'none',
                        position: 'static'
                    }}
                >
                    <Toolbar
                        sx={{
                            // display: 'flex',
                            // justifyContent: 'center',
                            // alignItems: 'center',
                            height: '18vh',
                            margin: '0 5% 0 5%',
                        }}
                    >
                        <IconButton
                            color="inherit"
                            aria-label="open drawer"
                            edge="start"
                            onClick={handleDrawerToggle}
                            sx={{ mr: 2, display: { sm: 'none' } }}
                        >
                            <MenuIcon /> MENU
                        </IconButton>

                        <Box sx={{ display: { xs: 'inline', sm: 'none' }, marginRight: 'auto' }}>
                            <Link to="/">
                                <img src={Logos} alt="Logos CNM e XXVI Marcha" style={{ width: '200px' }} />
                            </Link>
                        </Box>
                        <Grid sx={{ flexGrow: 1, display: { xs: 'none', sm: 'inline' } }}>
                            <Link to="/">
                                <img src={Logos} alt="Logos CNM e XXVI Marcha" style={{ width: '50%' }} />
                            </Link>
                        </Grid>

                        <Box sx={{ display: { xs: 'none', md: 'inline', sm: 'inline' } }}>
                            {navItems.map((item, index) => {
                                if (!item.popover) {
                                    return (
                                        <Button
                                            key={item.text}
                                            sx={{
                                                color: '#fff',
                                                fontSize: { xl: '1rem', lg: '0.8rem' },
                                                textTransform: 'none',
                                                ...(index === navItems.length - 1 && {
                                                    backgroundColor: '#FFBE00',
                                                    color: 'success.contrastText',
                                                    borderRadius: '11px',
                                                    paddingX: '15px',
                                                }),
                                            }}
                                            component={Link}
                                            to={item.route}
                                            target={index === navItems.length - 1 ? '_blank' : undefined}
                                            rel={index === navItems.length - 1 ? 'noopener noreferrer' : undefined}
                                        >
                                            {item.text}
                                        </Button>
                                    );
                                } else {
                                    return (
                                        <React.Fragment key={item.text}>
                                            <Popover
                                                id="duvidas-popover"
                                                open={Boolean(popoverAnchor)}
                                                anchorEl={popoverAnchor}
                                                onClose={handlePopoverClose}
                                                anchorOrigin={{
                                                    vertical: 'bottom',
                                                    horizontal: 'left',
                                                }}
                                                transformOrigin={{
                                                    vertical: 'top',
                                                    horizontal: 'left',
                                                }}
                                            >
                                                <List>
                                                    <ListItem disablePadding>
                                                        <BotaoDec />
                                                    </ListItem>
                                                    <ListItem disablePadding>
                                                        <BotaoValores />
                                                    </ListItem>
                                                    <ListItem disablePadding>
                                                        <BotaoCertidoes />
                                                    </ListItem>
                                                    <ListItem disablePadding>
                                                        <BotaoOrientacoes />
                                                    </ListItem>
                                                </List>
                                            </Popover>
                                            <Button
                                                aria-describedby={popoverAnchor ? 'duvidas-popover' : undefined}
                                                onClick={handlePopoverOpen}
                                                sx={{
                                                    color: '#fff',
                                                    fontSize: { xl: '1rem', lg: '0.8rem' },
                                                    textTransform: 'none',
                                                    ...(index === navItems.length - 1 && {
                                                        backgroundColor: '#FFBE00',
                                                        color: 'success.contrastText',
                                                        borderRadius: '11px',
                                                        paddingX: '15px',
                                                    }),
                                                }}
                                            >
                                                {item.text}
                                            </Button>
                                        </React.Fragment>
                                    );
                                }
                            })}
                        </Box>

                    </Toolbar>
                </AppBar>
                <nav>
                    <Drawer
                        container={container}
                        variant="temporary"
                        open={mobileOpen}
                        onClose={handleDrawerToggle}
                        ModalProps={{
                            keepMounted: true,
                        }}
                        sx={{
                            display: { xs: 'block', sm: 'none' },
                            '& .MuiDrawer-paper': { boxSizing: 'border-box', width: drawerWidth },
                        }}
                    >
                        <Box onClick={handleDrawerToggle} sx={{ textAlign: 'center' }}>
                            <List>
                                {navItems.map((item) => (
                                    <ListItem key={item.text} disablePadding>
                                        <ListItemButton sx={{ textAlign: 'center' }}>
                                            {item.popover ? (
                                                <Accordion>
                                                    <AccordionDetails>
                                                        <div style={{ display: 'flex', flexDirection: 'column' }}>
                                                            <BotaoDec />
                                                            <BotaoValores />
                                                            <BotaoCertidoes />
                                                            <BotaoOrientacoes />
                                                        </div>
                                                    </AccordionDetails>
                                                </Accordion>
                                            ) : (
                                                <Link to={item.route} style={{ textDecoration: 'none', color: 'inherit' }}>
                                                    <ListItemText primary={item.text} />
                                                </Link>
                                            )}
                                        </ListItemButton>
                                    </ListItem>
                                ))}
                            </List>
                        </Box>
                    </Drawer>
                </nav>
            </Box>

            <div>
                <Grid style={{ height: '22vh' }} />
                <Grid container justifyContent="flex-start" alignItems="center" sx={{ mt: { xs: '-35%', sm: '-8%', md: '-9%', lg: '-9%', xl: '-8%' } }}>
                    <Typography sx={{ color: '#FFFDFA', fontSize: { lg: '1.8rem', xl: '2rem', xs: '1.7rem' }, textAlign: 'center', marginLeft: { lg: '8vw', xl: '10vw', xs: '3vw' } }}>
                        Pacto Federativo: Um Olhar <br />
                        para a população desprotegida
                    </Typography>
                </Grid>

                <Grid container sx={{ width: '500px', marginLeft: { lg: '6.5vw', xl: '9vw', xs: '12vw' }, marginTop: '1rem', borderRadius: '5px' }}>
                    <iframe
                        width="560"
                        height="315"
                        src="https://www.youtube.com/embed/2l5Yd4T62TE?si=cdYCW2JtMtO42Mwg"
                        title="YouTube video player"
                        frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                        referrerpolicy="strict-origin-when-cross-origin" allowfullscreen
                    ></iframe>
                </Grid>
                <Grid sx={{ height: '45vh', mt: { xs: '15%', sm: '15%', md: '12%', lg: '2%', xl: '10%' } }}>
                    <Curva />
                    <Grid
                        sx={{
                            display: { xl: 'flex', lg: 'flex', xs: 'none' },
                            flexDirection: 'row',
                            alignItems: 'center',
                            justifyContent: 'center',
                            position: 'absolute',
                            top: {
                                xl: '770px',
                                lg: '550px',
                                xs: '-20%'
                            },
                            left: {
                                xl: '16%',
                                lg: '9%',
                                xs: '0'
                            },
                        }}
                    >
                        <BotaoProgramacao
                            foto={ProgramacaoPrincipal}
                            tipo="Principal"
                            link="/programacao"
                        />
                        <BotaoProgramacao
                            foto={ProgramacaoParalela}
                            tipo="Paralela"
                            link="/programacao#paralela"
                        />
                    </Grid>
                </Grid>

                <Grid sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column', marginTop: { xl: '2%', lg: '3%', xs: '-30%' }, marginBottom: '3%' }} >
                    <Grid sx={{ display: 'flex', flexDirection: 'row', marginBottom: '3%' }}>
                        <Typography sx={{ fontStyle: 'italic', color: '#03357C', fontWeight: 'bolder', fontSize: { xl: '2.5rem', xs: '1.5rem' }, marginRight: '5px' }}>
                            AUTORIDADES
                        </Typography>
                        <Typography sx={{ fontStyle: 'italic', color: '#0091FF', fontWeight: 'bolder', fontSize: { xl: '2.5rem', xs: '1.5rem' }, marginLeft: '5px' }}>
                            CONVIDADAS
                        </Typography>
                    </Grid>
                    <Grid sx={{ width: '99%', height: '45vh' }}>
                        <CarrosselConvidados />
                    </Grid>
                </Grid>

                <Grid sx={{ display: { xs: 'flex' }, alignItems: { xs: 'center' }, justifyContent: { xs: 'center' }, marginTop: { lg: '1vh', xs: '-5vh' }, marginBottom: { xl: '8vh', xs: '20vh' }, height: { xl: '45vh', lg: '50vh', xs: '100vh' }, backgroundColor: '#f5f5f5' }}>
                    <NumerosEvento />
                </Grid>

                <Grid sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column', marginBottom: '10%', gap: 7 }} >
                    <Grid sx={{ display: 'flex', flexDirection: 'row' }}>
                        <Typography sx={{ fontStyle: 'italic', color: '#0091FF', fontWeight: 'bolder', fontSize: { xl: '2.5rem', xs: '1.5rem' }, marginRight: '5px' }}>
                            PATROCINADORES
                        </Typography>
                    </Grid>
                    {/* <Grid sx={{ width: '100%', height: { xl: '17vh', lg: '24vh' }}} className='CarrosselApoiadores'>
                    <CarrosselApoiadores />
                </Grid> */}
                    <Grid sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                        <img src={Logomarcas} alt="Logomarcas patrocinadores" style={{ width: '80%' }} />
                    </Grid>
                </Grid>

                <Grid sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column', marginBottom: '5%' }} >
                    <Grid sx={{ display: 'flex', flexDirection: 'row' }}>
                        <Typography sx={{ fontStyle: 'italic', color: '#03357C', fontWeight: 'bolder', fontSize: { xl: '2.5rem', xs: '1.5rem' }, marginRight: '5px' }}>
                            ÚLTIMAS
                        </Typography>
                        <Typography sx={{ fontStyle: 'italic', color: '#0091FF', fontWeight: 'bolder', fontSize: { xl: '2.5rem', xs: '1.5rem' }, marginLeft: '5px' }}>
                            NOTÍCIAS
                        </Typography>
                    </Grid>
                    <Grid sx={{ width: { xl: '85%', lg: '90%', xs: '99%' }, height: '45vh' }}>
                        <CarrosselNoticias />
                    </Grid>
                </Grid>

                <Grid sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', marginTop: { xl: '5%', lg: '5%', xs: '20%' } }}>
                    <CardsEnd />
                </Grid>
            </div>
            <Footer />
        </div>
    );
}
